/* Cognito CNC quote repricing for the Online Store cart.
 * Quoted parts are sold as one "lot" whose price already includes the piece
 * quantity. When the customer changes the quantity of a quoted line, this
 * script asks quote.cognitomoto.com to recompute the volume price, then swaps
 * the line for newly priced merchandise. Regular products are untouched.
 *
 * Quoted lines are loaded up front so clicks can be intercepted synchronously,
 * before the theme's own quantity handlers add extra unpriced lots. */
(function () {
  var API = "https://quote.cognitomoto.com/api/public/reprice";
  var busy = false;
  var quoted = {}; // line key -> { key, token, pieces }

  function loadQuoted() {
    return fetch("/cart.js", { credentials: "same-origin" })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var map = {};
        (cart.items || []).forEach(function (item) {
          var p = item.properties || {};
          if (p["_quote"] && p["Pieces per lot"]) {
            map[item.key] = {
              key: item.key,
              token: p["_quote"],
              pieces: parseInt(p["Pieces per lot"], 10) || 1,
            };
          }
        });
        quoted = map;
        showPieces();
      })
      .catch(function () {});
  }

  // Quoted lines always have Shopify quantity 1 (one lot); show pieces instead.
  function showPieces() {
    Object.keys(quoted).forEach(function (key) {
      var inputs = document.querySelectorAll('.js-qty__num[data-id="' + cssEscape(key) + '"]');
      inputs.forEach(function (input) {
        if (busy) return;
        input.value = String(quoted[key].pieces);
      });
    });
  }

  function cssEscape(s) {
    return window.CSS && CSS.escape ? CSS.escape(s) : String(s).replace(/"/g, '\\"');
  }

  function reprice(item, pieces) {
    if (busy) return;
    pieces = Math.max(1, Math.min(100000, Math.floor(pieces || 1)));
    if (pieces === item.pieces) { showPieces(); return; }
    busy = true;
    document.body.style.cursor = "wait";
    document.querySelectorAll('.js-qty__num[data-id="' + cssEscape(item.key) + '"]').forEach(function (i) {
      i.value = String(pieces);
    });
    fetch(API, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token: item.token, pieces: pieces }),
    })
      .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
      .then(function (res) {
        if (!res.ok || !res.body.variantId) throw new Error(res.body.error || "Reprice failed");
        // Add the newly priced lot first, then remove the old one, so a failure
        // never leaves the customer with an empty cart.
        return fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "same-origin",
          body: JSON.stringify({
            items: [{ id: res.body.variantId, quantity: 1, properties: res.body.properties }],
          }),
        }).then(function (r) {
          if (!r.ok) throw new Error("Could not add repriced part");
          return fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            credentials: "same-origin",
            body: JSON.stringify({ id: item.key, quantity: 0 }),
          });
        });
      })
      .catch(function (err) {
        window.alert((err && err.message) || "Could not update the quantity for this part.");
      })
      .finally(function () { window.location.reload(); });
  }

  function keyFrom(el) {
    var row = el.closest && el.closest("[data-key]");
    if (row) return row.getAttribute("data-key");
    var input = el.closest && el.closest(".js-qty__wrapper");
    input = input && input.querySelector(".js-qty__num");
    return input ? input.getAttribute("data-id") : null;
  }

  // Capture phase + synchronous decision so the theme's handlers never run.
  document.addEventListener("click", function (evt) {
    var btn = evt.target.closest && evt.target.closest(".js-qty__adjust");
    if (!btn) return;
    var item = quoted[keyFrom(btn)];
    if (!item) return; // regular product — let the theme handle it
    evt.preventDefault();
    evt.stopImmediatePropagation();
    var delta = btn.classList.contains("js-qty__adjust--plus") ? 1 : -1;
    reprice(item, item.pieces + delta);
  }, true);

  document.addEventListener("change", function (evt) {
    var input = evt.target;
    if (!input.classList || !input.classList.contains("js-qty__num")) return;
    var item = quoted[input.getAttribute("data-id")];
    if (!item) return;
    evt.preventDefault();
    evt.stopImmediatePropagation();
    reprice(item, parseInt(input.value, 10));
  }, true);

  // Enter in the quantity box should reprice, not submit the cart form.
  document.addEventListener("keydown", function (evt) {
    if (evt.key !== "Enter") return;
    var input = evt.target;
    if (!input.classList || !input.classList.contains("js-qty__num")) return;
    var item = quoted[input.getAttribute("data-id")];
    if (!item) return;
    evt.preventDefault();
    evt.stopImmediatePropagation();
    reprice(item, parseInt(input.value, 10));
  }, true);

  // The cart drawer re-renders after changes; refresh our view of quoted lines.
  document.addEventListener("cart:updated", loadQuoted);
  document.addEventListener("cart:build", loadQuoted);
  var pending = null;
  new MutationObserver(function () {
    if (pending) return;
    pending = setTimeout(function () { pending = null; showPieces(); }, 50);
  }).observe(document.documentElement, { childList: true, subtree: true });

  loadQuoted();
})();
